import { MAX_BOOLEANS } from "../lib/utils";
import _ from "lodash";

export const isFulfilled = (action) => {
    return `${action}_FULFILLED`;
};

export const isRejected = (action) => {
    return `${action}_REJECTED`;
};

export const isPending = (action) => {
    return `${action}_PENDING`;
};

export const parseFilterData = (filters) => {
    if (!filters) return undefined;
    return filters.map((fltr) => {
        if (typeof fltr.filter_data === "string") fltr.filter_data = JSON.parse(fltr.filter_data);
        //temporary since publication has not been added to exisiting filters
        if (!fltr.filter_data.publications) fltr.filter_data.publications = ["selectAll"];
        // also entityType subtype
        if (!fltr.filter_data.entityType) fltr.filter_data.entityType = "all";
        if (!fltr.filter_data.entitySubType) fltr.filter_data.entitySubType = "all";
        if (!fltr.filter_data.filterKeyword) fltr.filter_data.filterKeyword = "";
        if (!fltr.filter_data.topicAccount) fltr.filter_data.topicAccount = "topic";
        return fltr;
    });
};
export const filterChangedFilters = (filters, topics, countries) => {
    let allTopicsList = _.uniq(topics.map((topic) => topic.topic_id));
    let allSubtopicsList = topics.map((topic) => topic.subtopic_id);
    let allCountries = countries.map((x) => x.id);

    if (topics.length < MAX_BOOLEANS) {
        allTopicsList.push("ALL");
        allSubtopicsList.push("ALL");
    }

    filters = filters.map((filter) => {
        filter.filter_data.topics = filter.filter_data.topics.filter((topic) => allTopicsList.includes(topic));
        filter.filter_data.subtopics = filter.filter_data.subtopics.filter((subtopic) => allSubtopicsList.includes(subtopic));
        filter.filter_data.countries = filter.filter_data.countries.filter((country) => allCountries.includes(country));
        return filter;
    });
    return filters;
};

/* export const searchKeywordFilter = (filters) => {
    if(sessionStorage.getItem('custom_query') && sessionStorage.getItem('searchDataType') && sessionStorage.getItem('searchDataType') == 2 ){      
      let filter = filters.find(elem => elem.name === 'ALL');
      filter.filter_data.filterKeyword = sessionStorage.getItem('custom_query');      
    }
    
} */

export const setLocalStorageVars = (vars) => {
    Object.keys(vars).forEach((key) => {
        if (key === "filters") {
            vars["filters"] = vars["filters"].filter((fltr) => fltr.id !== -999);
        }
        localStorage.setItem(key, JSON.stringify(vars[key]));
    }, this);
};

export const formatPublications = (publications) => {
    if (publications) {
        return publications.map((pub) => {
            pub.name = pub.name.toLowerCase();
            return pub;
        });
    }
    return [];
};
